import {
  Group,
  Identifiable,
  Project,
  ProjectResource,
  Resource,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { ListedResource, toListedResource } from "../utils/resourcesListing";
import { ListedMember, toProjectMember } from "./saveEveryoneInProject";

// The back adds every activated project member that isn't in the project group yet, and answers them.
function saveEveryoneInProjectResourceGroup(httpClient: HttpClient) {
  return (group: Identifiable<Group>, project: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest<ListedMember[]>({
        endpoint: `/projectResourceGroups/${group.uuid}/everyone`,
        method: HttpMethods.POST,
      })
      .then((members) =>
        members.map((member) => toProjectMember(member, project)),
      );
}

// The back adds every activated planzone resource that isn't in the planzone group yet, and answers them.
function saveEveryoneInPlanzoneResourceGroup(httpClient: HttpClient) {
  return (group: Identifiable<Group>) =>
    httpClient
      .sendHttpRequest<ListedResource[]>({
        endpoint: `/planzoneResourceGroups/${group.uuid}/everyone`,
        method: HttpMethods.POST,
      })
      .then((resources) => resources.map(toListedResource));
}

function saveEveryoneInResourceGroup(httpClient: HttpClient) {
  return (
    group: Identifiable<Group>,
    project?: Identifiable<Project>,
  ): Promise<Identifiable<Resource | ProjectResource>[]> =>
    group.resourceType === "project" && project
      ? saveEveryoneInProjectResourceGroup(httpClient)(group, project)
      : saveEveryoneInPlanzoneResourceGroup(httpClient)(group);
}

export { saveEveryoneInResourceGroup };
